var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindSpeed01 = function SvgWindSpeed01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 677.33 677.33",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wind_speed-01_svg2__a",
    x1: 66.27,
    x2: 571.27,
    y1: 603.62,
    y2: 147.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_speed-01_svg2__a",
    id: "wind_speed-01_svg2__b",
    x1: -87.04,
    x2: 417.96,
    y1: 433.83,
    y2: -22.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_speed-01_svg2__a",
    id: "wind_speed-01_svg2__c",
    x1: 123.1,
    x2: 628.1,
    y1: 666.56,
    y2: 210.56
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M548.44 362.67H130.67c-13.25 0-24-10.75-24-24s10.75-24 24-24h417.78c44.6 0 80.89-36.29 80.89-80.89s-36.29-80.89-80.89-80.89-80.89 36.29-80.89 80.89c0 13.25-10.75 24-24 24s-24-10.75-24-24c0-71.07 57.82-128.89 128.89-128.89s128.89 57.82 128.89 128.89-57.82 128.89-128.89 128.89Z",
    style: {
      fill: "url(#wind_speed-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.67 257.78H24c-13.25 0-24-10.75-24-24s10.75-24 24-24h226.67c44.6 0 80.89-36.29 80.89-80.89S295.27 48 250.67 48s-80.89 36.29-80.89 80.89c0 13.25-10.75 24-24 24s-24-10.75-24-24C121.78 57.82 179.6 0 250.67 0s128.89 57.82 128.89 128.89-57.82 128.89-128.89 128.89",
    style: {
      fill: "url(#wind_speed-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.56 677.33c-71.07 0-128.89-57.82-128.89-128.89 0-13.25 10.75-24 24-24s24 10.75 24 24c0 44.6 36.29 80.89 80.89 80.89s80.89-36.29 80.89-80.89-36.29-80.89-80.89-80.89H24c-13.25 0-24-10.75-24-24s10.75-24 24-24h419.56c71.07 0 128.89 57.82 128.89 128.89s-57.82 128.89-128.89 128.89",
    style: {
      fill: "url(#wind_speed-01_svg2__c)"
    }
  }));
};
export default SvgWindSpeed01;